import { Client } from "./client";

export class StripeApi {
  private client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  async createCheckoutSession(): Promise<string> {
    const response = await this.client.fetch(`/stripe/checkout`, {
      method: "POST",
    });

    const json = await response.json();

    return json.data.url;
  }
}
